/**
 * Copyright 2026, CS GROUP, https://www.cs-soprasteria.com/
 *
 * This file is part of AntFlow project.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import { TriggersProvider } from '@antflow-triggers-component';
import { Route, Routes } from 'react-router';
import { TriggerList } from './TriggerPages/TriggerList';
import { EditTrigger } from './TriggerPages/EditTrigger';
import { AppRoutes } from '@/constants/routes';
import { TriggerDetail } from './TriggerPages/TriggerDetail';
import { NewTrigger } from './TriggerPages/NewTrigger';
import { useStoreContext } from '@/contexts/StoreContext';

export const TriggersPage: React.FC = () => {
  const { antflowServerConfig } = useStoreContext();

  return (
    <TriggersProvider apiBaseUrl={antflowServerConfig?.apiUrl || 'http://localhost:8080'}>
      <Routes>
        <Route index element={<TriggerList />} />
        <Route path={AppRoutes.trigger.list.path} element={<TriggerList />} />
        <Route path={AppRoutes.trigger.new.path} element={<NewTrigger />} />
        <Route path={AppRoutes.trigger.edit.path} element={<EditTrigger />} />
        <Route path={AppRoutes.trigger.detail.path} element={<TriggerDetail />} />
      </Routes>
    </TriggersProvider>
  );
};
